import { Route } from 'react-router-dom';
import { isAdmin,isAuthenticated,getCurrentUser } from '../login/controller/login-controller';
import { getActionsForMenu } from '../utils/auth';

export const renderRoutesWithPermissions = (routes) => {

  //const { hasPermission } = usePermissionViewModel();
  const admin = isAdmin()
  const isAuth = isAuthenticated()
  const user=getCurrentUser()

  // const filteredRoutes = adminRoutes.filter((route) =>
  //   isAuth && hasPermission(route.menuName, route.action)
  // );
 if(isAuth){
  let filteredRoutes= admin ? routes : routes
  .filter((route) => {
   const actions = getActionsForMenu(route.menuName, user?.permissions) || [];
    return Array.isArray(route.action)
    ? route.action.some(action => actions.includes(action))
    : actions.includes(route.action);
  })

  return filteredRoutes.map((route) => (
    <Route key={route.path} path={route.path} element={route.element} />
  ));
 }


};
